class AdminStudentCreatePickupLocationController {

    constructor($stateParams){
        this.$stateParams = $stateParams;
        this.studentId = $stateParams.studentId;
    }
}
AdminStudentCreatePickupLocationController.$inject = ['$stateParams'];

export default AdminStudentCreatePickupLocationController;